import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, tap } from 'rxjs/operators';
import { SurveyDataService } from '../services/survey-data.service';
import { GetInterview, getInterviewSuccess, SurveyActionTypes } from './surveys.actions';

@Injectable()
export class SurveyEffects {
    constructor(
        private actions$: Actions,
        private surveyDataService: SurveyDataService
    ) {}

    public getInterview$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SurveyActionTypes.GetInterview),
            switchMap(({ interviewee, initiatedBy, surveyType, callback }: GetInterview) =>
                this.surveyDataService.getInterview({ interviewee, initiatedBy, surveyType }).pipe(
                    tap((interview) => {
                        if (callback) {
                            callback(interview);
                        }
                    }),
                    map((interview) => getInterviewSuccess({ interview }))
                )
            )
        )
    );
}
